var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1813_12946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1075 16.381L15.2735 13.0299L10.1057 16.0001L10.1055 16V31.9989L15.9377 35.3501V19.3512L15.9376 19.3511L21.1075 16.381Z",
    fill: "#2B2E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0298 8.00046L18.1958 11.3516L32.1202 19.3511V25.293L37.9525 21.9403V15.9999L24.0298 8.00046Z",
    fill: "#2B2E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9526 25.2981L24.03 33.2959L18.8604 30.3258V37.0297L24.03 40V39.9998L37.9526 31.9986V25.2981Z",
    fill: "#4AA6E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1813_12946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.7895,
    height: 32,
    fill: "white",
    transform: "translate(10.1055 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogo);
export default __webpack_public_path__ + "static/media/nav-logo.dd4b85fd8c4456195692039f65a4acad.svg";
export { ForwardRef as ReactComponent };